module.exports = "/_next/static/images/img__hand-220cd798bc39e5d6e2f86949da55c11d.png";